

function CopyChecker() {

};

export default CopyChecker;